<template>
    <div>
        <v-app-bar app color="primary" dark elevation="0">
            <v-app-bar-nav-icon @click.stop="sidebarMenu = !sidebarMenu"></v-app-bar-nav-icon>
            <div v-if="!sidebarMenu" class="d-flex mx-1 align-center fill-width grow">
                <div class="mx-auto d-flex flex-nowrap shrink align-center">
                    <v-btn text small class="btn-links" to="/stays"><span class="d-none d-sm-inline">Stays</span><v-icon class="d-sm-none">mdi-home-flood</v-icon></v-btn>
                    <v-btn text small class="btn-links d-none" to="/places"><span class="d-none d-sm-inline">Places</span><v-icon class="d-sm-none">mdi-home-map-marker</v-icon></v-btn>
                    <router-link to="/" class="font-weight-bold mx-3" tag="h2">
                        HipCabin
                    </router-link>
                    <v-btn text small class="btn-links d-none" to="/tools"><span class="d-none d-sm-inline">Tools</span><v-icon class="d-sm-none">mdi-home-assistant</v-icon></v-btn>
                    <v-btn text small class="btn-links" to="/goods"><span class="d-none d-sm-inline">Shop</span><v-icon class="d-sm-none">mdi-home-currency-usd</v-icon></v-btn>
                </div>
            </div>
            <v-icon class="ml-auto" shrink>mdi-account</v-icon>
        </v-app-bar>
        <v-navigation-drawer 
            v-model="sidebarMenu" 
            app
            floating
            :permanent="sidebarMenu"
            :mini-variant.sync="mini"
            >
            <v-list dense>
                <v-list-item>
                    <v-list-item-action>
                        <v-icon @click.stop="sidebarMenu = !sidebarMenu">mdi-chevron-left</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-action-text>
                            <router-link to="/" class="font-weight-bold mr-1" tag="h2">
                                HipCabin
                                <v-icon color="black" large>mdi-home-circle-outline</v-icon>
                            </router-link>
                        </v-list-item-action-text>
                    </v-list-item-content>
                </v-list-item>
            </v-list>
            <v-list-item class="px-2 d-none" @click="toggleMini = !toggleMini">
                <v-list-item-avatar>
                    <v-icon>mdi-account-outline</v-icon>
                </v-list-item-avatar>
                <v-list-item-content class="text-truncate">
                    My joy
                </v-list-item-content>
                <v-btn icon small>
                    <v-icon>mdi-chevron-left</v-icon>
                </v-btn>
            </v-list-item>
            <v-divider></v-divider>
            <v-list>
                <v-list-item v-for="item in items" :key="item.title" link :to="item.href">
                    <v-list-item-icon :title="item.name">
                        <v-icon color="primary">{{ item.icon }}</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title class="primary--text" :title="item.title">{{ item.name }}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </v-list>
        </v-navigation-drawer>
    </div>
</template>
<script>
// import { mapState, mapGetters } from 'vuex'
export default {
    data: () => ({
        dialogTags: false,
        tagsFilter: null,
        sidebarMenu: false,
        toggleMini: false,
        items: [
            { name:"Stays", href:"/stays", icon:"mdi-home-flood", title: "The most unique & stylish bnb stays around the globe" },
            //{ name:"Destinations", href:"/places", icon:"mdi-home-map-marker", title: "Top destinations in the US and beyond" },
            //{ name:"Tools", href:"/tools", icon:"mdi-home-edit-outline", title: "Marketing, tips and resources for bnb-ing" },
            //{ name:"Style", href:"/style", icon:"mdi-home-heart", title: "Tips, tricks and tools of the trade" },
            { name:"Goods", href:"/goods", icon:"mdi-home-currency-usd", title: "Goods, gifts and gear for bnb hosts and nomad travelers" },
            //{ name:"Forums", href:"/ask", icon:"mdi-home-assistant", title: "Questions, help, advice &amp; answers by and for bnb-ers" },
        ],
    }),
    props: {
        showAd: {
            type: Boolean,
            required: false,
            default: true
        }
    },
    components: {
        
    },
    methods: {
        
    },
    created () {
    },
    computed: {
        mini: {
            get() {
				return (this.$vuetify.breakpoint.smAndDown) || this.toggleMini
			},
			set(value) {
				console.log("setter called with value", value)
			},
        },
    },
}
</script>
<style>

</style>